import { ReactNode } from "react"
import style from "./BottomBar.module.scss"

const { bottomBar } = style

type Props = { children: ReactNode; className?: string }

export const BottomBar = ({ children, className = "" }: Props) => {
	return <div className={`${bottomBar} ${className}`}>{children}</div>
}
